import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SmService } from '../../../pages/sm/services/sm.service';
import { SmDataService } from '../../../pages/sm/services/sm-data.service';
import { HomeService } from '../../../pages/home/services/home.service';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { UtilityService } from '../../../core/services/utility.service';
import moment from 'moment';
import { ClockAction_Request } from '@typeDefs/employee/requests/employee';

@Component({
  selector: 'app-clock-in-modal',
  templateUrl: './clock-in-modal.component.html',
  styleUrls: ['./clock-in-modal.component.css'],
})
export class ClockInModalComponent implements OnInit {
  alert: any;
  lookupList: any;
  clockIn: boolean;
  formData: { [key: string]: any };
  tripListFiltered: any;
  employeeInfo: any;
  lookupReady = false;

  constructor(
    private ngbActiveModal: NgbActiveModal,
    private smService: SmService,
    public smDataService: SmDataService,
    private employeeInfoService: EmployeeInfoService,
    private homeService: HomeService,
    public utilityService: UtilityService
  ) {
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  ngOnInit(): void {
    this.formData = {};
    this.tripListFiltered = [];
    this.formData.selectedTrip = null;

    let counter = 0;
    if (this.smDataService.tripList != null) {
      this.smDataService.tripList.forEach((val: any) => {
        if (val.ScopeData != null && val.SMTripID != null) {
          this.tripListFiltered.push({
            ScopeData: val.ScopeData,
            WorkOrder: val.WorkOrder,
            SMTripID: val.SMTripID,
            SMWorkOrderID: val.SMWorkOrderID,
            ScheduledDateDisplay: val.ScheduledDateDisplay,
            Display:
              (val.ScheduledDateDisplay != null ? val.ScheduledDateDisplay + ' - ' : '') +
              'WO #' +
              val.WorkOrder +
              ' ' +
              val.TripDescription,
            Index: counter++,
            SMCo: val.SMCo,
          });
        }
      });
    }

    if (this.smDataService.currentWorkOrder != null) {
      this.tripListFiltered.forEach((val: any) => {
        if (val.SMTripID == this.smDataService.currentWorkOrder.SMTripID) {
          this.formData.selectedTrip = val.Index;
          this.getPayType();
        }
      });
    }
  }

  closeAlert() {
    this.alert = null;
  }

  getPayType() {
    this.formData.selectedScope = null;
    this.formData.selectedPayType = null;

    if (this.tripListFiltered[this.formData.selectedTrip].ScopeData.length == 1) {
      this.formData.selectedScope = this.tripListFiltered[this.formData.selectedTrip].ScopeData[0].SMWorkOrderScopeID;
    }

    if (this.smDataService.currentWorkOrderScopeData != null) {
      this.formData.selectedScope = this.smDataService.currentWorkOrderScopeData.SMWorkOrderScopeID.toString();
    }

    this.smService.getSettingsBySMCo(this.tripListFiltered[this.formData.selectedTrip].SMCo).then((settings: any) => {
      this.smService.getCommonLookups(this.tripListFiltered[this.formData.selectedTrip].SMCo).then((response: any) => {
        this.lookupList = {};

        response.forEach((val: any) => {
          if (!this.lookupList.hasOwnProperty(val.LookupType)) this.lookupList[val.LookupType] = [];
          if (!isNaN(val.Code) && val.LookupType != 'SMPayType') val.Code = parseInt(val.Code);
          if (val.LookupType == 'SMPayType' || val.LookupType == 'SMCallType') {
            val.Code = val.Code.toString();
          }
          this.lookupList[val.LookupType].push(val);
        });

        let payTypeExist = false;

        this.lookupList['SMPayType'].forEach((val: any) => {
          if (settings[0].DefaultPayType.toString() == val.Code.toString()) payTypeExist = true;
        });

        if (payTypeExist) this.formData.selectedPayType = settings[0].DefaultPayType.toString();

        if (this.lookupList.hasOwnProperty('INLocation')) {
          if (this.lookupList['INLocation'] != null && this.lookupList['INLocation'].length > 0) {
            this.lookupList['INLocation'].unshift({
              Code: null,
              CodeDescription: 'No Location',
              Company: this.tripListFiltered[this.formData.selectedTrip].SMCo,
              LookupType: 'INLocation',
            });
          }
        }

        this.lookupReady = true;
      });
    });
  }

  public clockInClicked() {
    const currentTime = moment();
    const clockTimeString = currentTime.format('MM/DD/YYYY h:mm:ss a');
    let latitude = null;
    let longitude = null;

    if (this.smDataService.position != null && this.smDataService.position.coords != null) {
      latitude = this.smDataService.position.coords.latitude;
      longitude = this.smDataService.position.coords.longitude;
    }
    this.openModal('Clock In...');
    const requestObj: ClockAction_Request = {
      GPSLat: latitude,
      GPSLong: longitude,
      ClockAction: true,
      ClockTimeString: clockTimeString,
      Employee: this.employeeInfo.Employee,
      PRCo: this.employeeInfo.PRCo,
      SMWorkOrderScopeID: this.formData.selectedScope,
      SMPayType: this.formData.selectedPayType,
      SMTripID:
        this.tripListFiltered[this.formData.selectedTrip].SMTripID == null
          ? '-2'
          : this.tripListFiltered[this.formData.selectedTrip].SMTripID,
      FromGroupClock: false,
      KioskPass: null,
      SignatureData: null,
    };
    this.homeService.postClockAction(requestObj).then((response: any) => {
      if (response.success) {
        this.ngbActiveModal.close(response.success);
      } else {
        this.alert = response.error;
        this.utilityService.closeModal();
      }
    });
  }

  public openModal(msg: any) {
    this.smDataService.modalMsg = msg;
    this.utilityService.openModal();
  }

  public cancelClicked() {
    this.ngbActiveModal.dismiss();
  }
}
